import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";

export default function HeroCarousel() {
  const featured = movies.filter((m) => m.featured && m.banner);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (featured.length <= 1) return;
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % featured.length);
    }, 6000);
    return () => window.clearInterval(timer);
  }, [featured.length]);

  if (featured.length === 0) return null;
  const active = featured[index];

  const go = (dir: number) => {
    setIndex((prev) => (prev + dir + featured.length) % featured.length);
  };

  return (
    <section className="relative w-full h-[440px] md:h-[560px] overflow-hidden bg-foreground-950">
      {featured.map((movie, i) => (
        <div
          key={movie.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === index ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={movie.banner}
            alt={`${movie.title} 剧照`}
            title={`${movie.title} - 国产久久久`}
            className="w-full h-full object-top object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/55 to-foreground-950/20"></div>
        </div>
      ))}

      <div className="relative z-10 w-full h-full px-4 md:px-8 flex items-center">
        <div key={active.id} className="max-w-xl animate-fade-up">
          <div className="flex items-center gap-2 mb-4">
            <span className="px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs">
              {active.type === "movie" ? "电影" : "电视剧"}
            </span>
            <span className="px-2.5 py-1 rounded-md bg-background-50/15 text-background-50 text-xs backdrop-blur">
              {active.genres.join(" · ")}
            </span>
            <span className="px-2.5 py-1 rounded-md bg-accent-500/90 text-foreground-950 text-xs font-medium">
              评分 {active.rating.toFixed(1)}
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
            {active.title}
          </h2>
          <p className="mt-4 text-sm md:text-base text-background-200 leading-relaxed line-clamp-2 md:line-clamp-3">
            {active.summary}
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Link
              to={`/detail/${active.id}`}
              className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              查看详情
            </Link>
            <Link
              to={`/category/${active.type}`}
              className="px-5 py-2.5 rounded-md border border-background-50/40 text-background-50 text-sm whitespace-nowrap cursor-pointer hover:bg-background-50/10 transition-colors"
            >
              进入分类
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 right-4 md:right-8 z-10 flex items-center gap-3">
        <div className="flex items-center gap-2 mr-1">
          {featured.map((movie, i) => (
            <button
              key={movie.id}
              type="button"
              aria-label={`切换到 ${movie.title}`}
              onClick={() => setIndex(i)}
              className={`h-1.5 rounded-full transition-all cursor-pointer ${
                i === index ? "w-6 bg-primary-500" : "w-1.5 bg-background-50/50"
              }`}
            ></button>
          ))}
        </div>
        <button
          type="button"
          aria-label="上一张"
          onClick={() => go(-1)}
          className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-full bg-background-50/15 text-background-50 backdrop-blur cursor-pointer hover:bg-background-50/25 transition-colors"
        >
          <i className="ri-arrow-left-s-line text-lg"></i>
        </button>
        <button
          type="button"
          aria-label="下一张"
          onClick={() => go(1)}
          className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-full bg-background-50/15 text-background-50 backdrop-blur cursor-pointer hover:bg-background-50/25 transition-colors"
        >
          <i className="ri-arrow-right-s-line text-lg"></i>
        </button>
      </div>
    </section>
  );
}